import styled from 'styled-components';
import { CardMedia, CardActions, Card, Avatar } from '@material-ui/core';

export const LogoContainer = styled(Avatar)`
  background-color: ${({ theme: { palette } }) => palette.secondary.main};
  &&& {
    width: 105px;
    height: 88px;
  }
`;

export const MainFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  background-image: radial-gradient(
    circle at 50% 14em,
    #5c6183 0%,
    #484d68 60%,
    #242631 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
`;

export const Wallpaper = styled(CardMedia)`
  position: absolute;
  &&& {
    background-position: bottom;
    background-size: 100%;
  }
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const Logo = styled(CardMedia)`
  width: 100%;
  height: 100%;
`;

export const LoginCard = styled(Card)`
  min-width: 300px;
  margin-top: 6em;
  z-index: 3;
`;

export const LoginActions = styled(CardActions)`
  padding: 0 1em 1em 1em;
`;

export const AvatarContainer = styled.div`
  margin: 1em;
  display: flex;
  justify-content: center;
`;

export const InputContainer = styled.div`
  margin-top: 1em;
`;

export const FormContainer = styled.div`
  padding: 0 1em 1em 1em;
`;
